import state from './state'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

import createPersistedState from 'vuex-persistedstate'

export default {
  plugins: [createPersistedState()],
  state,
  getters,
  actions,
  mutations
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/auth/index.js
// module id = null
// module chunks = 